(function($) {

	'use strict';

	var init = function() {
		//Tarteaucitron event
		$(document).on('gtag_loaded', function(){
			initAdWords();
		});
	}

    var isCps = document.querySelector('.landingPage--cps') ? true : false;

	var initAdWords = function(){
		var count = 0;
		var gtagInterval = setInterval(function(){
			count++;
			if(typeof gtag === "function"){

				gtag('config', (isCps ? 'AW-10845349117' : 'AW-10813357486'));

                eventListeners();

				clearInterval(gtagInterval);

			} else if(count > 1000) {

				clearInterval(gtagInterval);
				console.error("gtag Not initialized");

			}
		}, 40);
	}

    //General event
    function gtag_report_conversion(url, sendTo) {

        var callback = function () {
        
        // if (typeof(url) != 'undefined') {
        
        //     window.location = url;
        
        // }
        
        };
        
        gtag('event', 'conversion', {
        
            'send_to': sendTo,
        
            'event_callback': callback
        
        });
        
        return false;
        
    }

    function eventListeners() {

        //Landing pages
        if($('.landingPageForm').length) {
            $(document).on("gform_confirmation_loaded", function() {
                gtag('event', 'conversion', {
                    'send_to': (isCps ? 'AW-10845349117/Kj8nCL7GwKsDEP3Ju7Mo' : 'AW-10813357486/sfAVCJfr_YgDEK77mqQo'),
                });
            });
        }
        if($('.lpHeader__phone--mobile').length) {
            $('.lpHeader__phone--mobile').on('click', function() {
                gtag('event', 'conversion', {
                    'send_to': (isCps ? 'AW-10845349117/jFHLCMHGwKsDEP3Ju7Mo' : 'AW-10813357486/fkd2CKyQzogDEK77mqQo'),
                });
            });
        }
        if($('.lpHeader__phone--desktop').length) {
            $('.lpHeader__phone--desktop').on('click', function() {
                gtag('event', 'conversion', {
                    'send_to': (isCps ? 'AW-10845349117/jFHLCMHGwKsDEP3Ju7Mo' : 'AW-10813357486/fkd2CKyQzogDEK77mqQo'),
                });
            });
        }
        if($('.lpHeader__phone__sticky').length) {
            $('.lpHeader__phone__sticky').on('click', function() {
                gtag('event', 'conversion', {
                    'send_to': (isCps ? 'AW-10845349117/jFHLCMHGwKsDEP3Ju7Mo' : 'AW-10813357486/fkd2CKyQzogDEK77mqQo'),
                });
            });
        }

        //Ticket 31789
        $(document).on("gform_confirmation_loaded", function(event, formId) {

            //Contactez-nous
            if(formId == 5) {
                gtag_report_conversion(window.location.href, 'AW-10813357486/S761CNaHu4sYEK77mqQo')
            }

            //Candidatez en ligne
            if(formId == 4) {
                gtag_report_conversion(window.location.href, 'AW-10813357486/RzCXCNOHu4sYEK77mqQo')
            }

            //Documentation
            if(formId == 1) {
                gtag_report_conversion(window.location.href, 'AW-10813357486/EImeCKKrxosYEK77mqQo')
            }

        })

    }

	$(document).ready(function() {
        init();
	});

})(jQuery);